var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-sales-report-data"},[(_vm.isNewProject)?_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('saveNewProjectFirst')))]):_c('MobileProjectsSalesReport',{attrs:{"project":_vm.project,"saveCard":_vm.saveCard,"reportTemplateImages":_vm.project.reportTemplateImages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }